import React, { useEffect, useState } from "react";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import ContentCard from "./ContentCard";
import { Box, Card, Grid, Typography } from "@mui/material";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { getOneActiveClassDetails } from "../../Api/DashboardApi";
import { fDate } from "../../../../../utils2/formatTime";

export default function TaskAndEnrolledDetails() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [activeClassDetails, SetactiveClassDetails] = useState(null);
  const [classLoading, setClassLoading] = useState(false);
  const handleNavigatessignment = () => {
    window.open("/test-prep/classroom", "_blank");
  }

  const handleNavigatePerformance = () => {
    window.open("/test-prep/performance", "_blank");
  }

  useEffect(() => {
    setClassLoading(true);
    const fetTestTypes = async () => {
      try {
        const data = await getOneActiveClassDetails(userId);
        SetactiveClassDetails(data?.data);
      } catch (err) {
        console.error("Could not fetch class details");
      } finally {
        console.error("Could not fetch  class details");
        setClassLoading(true);
      }
    };

    fetTestTypes();
  }, []);
  return (
    <CustomCardWithBorder boxShadow={true} padding="10px">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <ContentCard
            firstImage={
              <img src="/newdashboard/Taskandnenrollcard/Group 1000016414.png" />
            }
            Title="Assigned Task"
            Subtitle="Track and manage all your tasks easily"
            buttonName="View task"
onClick={handleNavigatessignment}
            sideImage1={
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9318.png" />
            }
            sideImage2={
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9319.png" />
            }
          />

          <ContentCard
            firstImage={
              <img src="/newdashboard/Taskandnenrollcard/Group 1000016414.png" />
            }
            Title="Grades"
            Subtitle="Check your scores and performance."
            buttonName="View grades"
            onClick={handleNavigatePerformance}
            topImage1={
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9318 (1).png" />
            }
            topImage2={
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9319 (1).png" />
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Card
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderRadius: 3,
              boxShadow: "0px 0px 3.81px rgba(0, 0, 0, 0.25)",

              // maxWidth: 320,
              border: "1px solid #EAE3E3",
              position: "relative",
            }}
          >
            {/* Icon Section */}
            <Box position="absolute" right={0} bottom={0}>
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9318 (2).png" />
            </Box>
            <Box position="absolute" right={0} bottom={0}>
              <img src="/newdashboard/Taskandnenrollcard/Ellipse 9319 (2).png" />
            </Box>

            <Grid container spacing={2} zIndex={1}>
              <Grid item xs={6} md={8}>
                <Typography
                  fontFamily="Inter"
                  color="#252525"
                  sx={{ fontWeight: 700, fontSize: "16px" }}
                >
                  Enrolled Class
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                md={4}
                display="flex"
                alignItems="center"
                justifyContent="end"
                gap={1}
                style={{ cursor: "pointer" }}
              >
                <Typography
                  fontSize="12px"
                  color="#572575"
                  sx={{ fontWeight: 400, fontFamily: "Inter" }}
                  onClick={() => navigate("/test-prep/classroom")}
                >
                  View All
                </Typography>
                <KeyboardArrowRightIcon
                  style={{ color: "#572575", fontSize: "1rem" }}
                  onClick={() => navigate("/test-prep/classroom")}
                />
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: "7.5px",
                    background: "#FBF4FF",
                    color: "#572575",
                    borderRightColor: "#ADADAD",
                    boxShadow: "0px 0px 4px 0px #ADADAD",
                  }}
                >
                  <Typography
                    textAlign="center"
                    fontSize="Inter"
                    color="#572575"
                    sx={{ fontWeight: 600, fontSize: "14px" }}
                  >
                    {activeClassDetails?.class_id?.name || "No Class"} 
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} display="flex" gap={2}>
                <Box
                  width="50%"
                  sx={{
                    background: "#EBFFE2",
                    border: "1px solid #CAF3B7",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <Typography
                    fontFamily="Inter"
                    color="#413F3F"
                    sx={{ fontWeight: 500, fontSize: "13px" }}
                  >
                    Active Sessions{" "}
                  </Typography>

                  <Typography
                    fontFamily="Inter"
                    mt={1}
                    color="#313439"
                    sx={{ fontWeight: 700, fontSize: "16px" }}
                  >
                    {activeClassDetails?.active_total_sessions || "0"}{" "}
                  </Typography>
                </Box>
                <Box
                  width="50%"
                  sx={{
                    background: "#FFEBF0",
                    border: "1px solid #FFC7D5",
                    borderRadius: "7px",
                    padding: "10px",
                  }}
                >
                  <Typography
                    fontFamily="Inter"
                    color="#413F3F"
                    sx={{ fontWeight: 500, fontSize: "13px" }}
                  >
                    Remaining Sessions{" "}
                  </Typography>

                  <Typography
                    fontFamily="Inter"
                    mt={1}
                    color="#313439"
                    sx={{ fontWeight: 700, fontSize: "16px" }}
                  >
                    {activeClassDetails?.remaining_sessions || "0"}{" "}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  fontFamily="Inter"
                  color="#D50C11"
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                >
                  {" "}
                  Last Date : {activeClassDetails?.end_date ? fDate(activeClassDetails?.end_date) : "-" }
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </CustomCardWithBorder>
  );
}
